var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTechno = function SvgTechno(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#techno_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#techno_svg__b)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.725 8.687A1.686 1.686 0 0 0 21.038 7h-10.12A1.685 1.685 0 0 0 9.23 8.687v8.998c0 .31.252.562.563.562h12.37c.31 0 .562-.251.562-.562V8.687ZM21.6 17.123V8.687a.561.561 0 0 0-.562-.562h-10.12a.563.563 0 0 0-.563.562v8.436H21.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.703 17.461a.563.563 0 0 0-.516-.336H9.812a.563.563 0 0 0-.515.336s-1.52 3.463-2.213 5.447a1.494 1.494 0 0 0 .279 1.47c.324.386.834.622 1.38.622h14.513c.547 0 1.056-.236 1.38-.622.355-.423.455-.969.28-1.47-.694-1.984-2.213-5.447-2.213-5.447ZM10.375 22.75h11.25a.563.563 0 0 0 0-1.125h-11.25a.563.563 0 0 0 0 1.125Zm3.375-3.375a.563.563 0 1 1 0 1.125.563.563 0 0 1 0-1.125Zm2.25 0a.563.563 0 1 1 0 1.125.563.563 0 0 1 0-1.125Zm2.25 0a.563.563 0 1 1 0 1.125.563.563 0 0 1 0-1.125ZM10.937 20.5h.563a.563.563 0 0 0 0-1.125h-.563a.563.563 0 0 0 0 1.125Zm9.563 0h.562a.563.563 0 0 0 0-1.125H20.5a.563.563 0 0 0 0 1.125ZM9.813 16h12.374a.563.563 0 0 0 0-1.125H9.813a.563.563 0 0 0 0 1.125Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.813 15.565h12.093v2.272H9.813v-2.272Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "techno_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(7 7)",
    d: "M0 0h18v18H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "techno_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(7 7)",
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgTechno;